import { Shield, CheckCircle, Lock, Eye, FileText, Users } from 'lucide-react';

export default function QualitySecurityPage() {
  return (
    <div className="min-h-screen py-24 md:py-32 bg-background" data-testid="quality-security-page">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-sm font-medium tracking-wider uppercase text-primary mb-3 block">Nos standards</span>
          <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Qualité, sécurité et conformité
          </h1>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            La confiance est au centre de notre démarche. Chaque aspect de notre service est conçu pour garantir qualité, sécurité et transparence.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {[
            { icon: Shield, title: "Sélection des partenaires", desc: "Chaque partenaire est évalué selon des critères objectifs d'accessibilité, de qualité de service et de fiabilité. Nous vérifions les installations, les qualifications et les retours d'expérience." },
            { icon: CheckCircle, title: "Processus qualité", desc: "Un suivi systématique de la satisfaction après chaque séjour. Les retours alimentent notre démarche d'amélioration continue et la notation de nos partenaires." },
            { icon: Lock, title: "Protection des données", desc: "Conformité RGPD dès la conception. Minimisation des données collectées, cloisonnement logique, consentements explicites, journalisation des accès aux dossiers." },
            { icon: Eye, title: "Transparence", desc: "Des devis détaillés et transparents. Aucun frais caché. Des conditions clairement exposées avant toute validation." },
            { icon: FileText, title: "Traçabilité", desc: "Chaque action, chaque échange est tracé pour garantir un suivi rigoureux et permettre un audit en cas de besoin." },
            { icon: Users, title: "Formation continue", desc: "Notre équipe est formée aux enjeux de l'accessibilité, du handicap et de l'accompagnement des personnes en perte d'autonomie." }
          ].map(({ icon: Icon, title, desc }) => (
            <div key={title} className="bg-white rounded-2xl p-8 border border-border/30 shadow-sm">
              <Icon className="w-8 h-8 text-primary mb-4" />
              <h3 className="font-heading text-lg font-semibold mb-3">{title}</h3>
              <p className="text-muted-foreground leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-primary text-primary-foreground rounded-3xl p-8 md:p-12">
          <h2 className="font-heading text-2xl font-semibold mb-4 text-center">Notre engagement</h2>
          <p className="text-primary-foreground/80 leading-relaxed text-center max-w-2xl mx-auto">
            M-CareLink est une plateforme de coordination et de mise en relation. Nous ne sommes pas un établissement de santé et ne prétendons pas délivrer des prestations médicales. Notre rôle est d'organiser, coordonner et faciliter l'accès à des séjours de répit adaptés grâce à un réseau de partenaires professionnels qualifiés.
          </p>
        </div>
      </div>
    </div>
  );
}
